import { forwardRef } from 'react'
import { Button as RsuiteButton, ButtonProps } from 'rsuite'
import './button.scss'

// Forwards its ref through to the underlying rsuite button. Overlay triggers
// (Whisper/Tooltip/Popover) measure the element they wrap via that ref — with a
// plain function component there is nothing to measure and the overlay lands in
// the viewport's top-left corner instead of next to the button.
const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <RsuiteButton
        {...props}
        ref={ref}
        className={className ? `button ${className}` : 'button'}
      >
        {children}
      </RsuiteButton>
    )
  }
)

Button.displayName = 'Button'

export default Button
